﻿import { ValgStateActionTypes, ValgState, TOGGLE_VILKAR } from './Types';

export const initialState: ValgState = {
    visVilkar: false,
};

export function valgReducer(state: ValgState = initialState, action: ValgStateActionTypes): ValgState {
    switch (action.type) {
        case TOGGLE_VILKAR: {
            return {
                ...state,
                visVilkar: !state.visVilkar,
            };
        }
        default:
            return state;
    }
}
